<style scoped lang="scss">
.page-inner {
    max-width: 1200px;
    margin: 0 auto;
}

.page-title {
    display: flex;
    align-items: center;
    gap: 8px;

    .title-text {
        font-size: 16px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.88);
    }
}

.query-card {
    max-width: 720px;
    border-radius: 8px;

    :deep(.ant-card-head) {
        border-bottom: 1px solid #f0f0f0;
        padding: 0 16px;
        min-height: 48px;
    }

    :deep(.ant-card-body) {
        padding: 24px;
    }
}

.form-group {
    margin-bottom: 16px;

    label {
        display: block;
        font-size: 13px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.65);
        margin-bottom: 8px;
    }

    .mt-3 {
        margin-top: 0;
    }

    :deep(.ant-input),
    :deep(.ant-select) {
        width: 100%;
    }
}

.submit-btn {
    display: inline-block;
    min-width: 140px;
    height: 40px;
    padding: 0 24px;
    margin-top: 8px;
    background: #1677ff;
    color: #fff;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background: #0958d9;
    }
}

.query-footer {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #f0f0f0;

    p {
        font-size: 12px;
        color: #8c8c8c;
        margin: 0;
    }
}
</style>
<template>

    <a-layout style="min-height: 100vh;">
        <UserHead />
        <a-layout>
            <a-layout-header style="padding: 0; background: #fff; border-bottom: 1px solid #f0f0f0;">
                <HeadTop />
            </a-layout-header>
            <a-layout-content class="page-content" style="padding: 24px; background: #f5f7fa;">
                <div class="page-inner">
                    <a-card :bordered="false" class="query-card">
                        <template #title>
                            <div class="page-title">
                                <span class="title-text">授权查询</span>
                            </div>
                        </template>
                        <div class="form-group">
                            <label>授权字段</label>
                            <a-input v-model:value="form.host" placeholder="请输入授权字段(ip/域名/机器码等)" allowClear></a-input>
                        </div>

                        <div class="form-group">
                            <label>选择插件</label>
                            <a-select v-model:value="form.id" placeholder="请选择要查询的插件" :popup-match-select-width="false">
                                <a-select-option v-for="item in includes_data" :key="item.id" :value="item.id">
                                    {{ item.name }}
                                </a-select-option>
                            </a-select>
                        </div>

                        <button class="submit-btn" @click="getQuery">立即查询</button>

                        <div class="query-footer">
                            <p>支持域名、IP、卡密等多种方式查询</p>
                        </div>
                    </a-card>
                </div>
            </a-layout-content>
        </a-layout>
    </a-layout>

</template>
<script>
import { defineComponent } from 'vue';
import axios from 'axios';
import { message } from 'ant-design-vue'
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import UserHead from '@/components/UserHead.vue'
import HeadTop from '@/components/UserHeadTop.vue'
import { getIncludesList } from '@/utils/publicMethods'
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
    name: 'QueryView',
    components: {
        UserHead,
        HeadTop
    },
    data() {
        return {
            form: {
                host: "",
                id: "",
            },
            includes_data: [],
        }
    },
    methods: {
        getQuery() {
            openLoading()
            axios.get(baseURL + '/getTime?host=' + this.form.host + '&id=' + this.form.id, { timeout: 30000 })
                .then(res => {
                    if (res.data.code == 200) {
                        message.success(res.data.msg);
                    } else {
                        message.error(res.data.msg);
                    }
                }).catch(err => {
                    message.error(err);
                }).finally(() => {
                    fullscreenLoading.close()
                })

        },
        async getIncludes() {
            const res_data = await getIncludesList(999, 1);
            if (res_data.code != 0) {
                message.error(res_data.msg)
                return
            }
            this.includes_data = res_data.data
        }
    },
    mounted() {
        this.getIncludes()
    }
})
</script>
